module.exports = __webpack_public_path__ + "static/media/gn.e2dcda47.svg";